'use client'

import clsx from 'clsx';
import Image from 'next/image';
import { memo, useCallback, useState } from 'react';
import no_image from '../../../public/images/no_image.jpg';

// const NO_PREVIEW_IMAGE = 'no-preview.png';

const ImageWrapper = memo(({
	width = 100,
	height = 100,
	src,
	alt = 'Image',
	className
}: {
	width?: number,
	height?: number,
	src: string,
	alt?: string,
	className?: string
}) => {
	const [imageState, setImageState] = useState<'original' | 'fallback'>('original');

	const isValidSrc = useCallback((checkSrc: string) => {
		return typeof checkSrc === 'string' && (
			checkSrc?.includes('http') ||
			checkSrc?.includes('https') ||
			checkSrc?.includes('data:image/') ||
			checkSrc?.[0] === '@' ||
			checkSrc?.[0] === '/'
		);
	}, []);

	const handleImageError = useCallback(() => {
		setImageState('fallback');
	}, []);

	return (
		<Image
			width={width}
			height={height}
			src={(imageState === 'fallback' || !isValidSrc(src)) ? no_image : src}
			loading="lazy"
			alt={alt}
			className={clsx('', className)}
			onError={handleImageError}
			// placeholder="blur"
			// blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=="
		/>
	);
});

export default ImageWrapper;
